import { render } from "./TryGame.vue?vue&type=template&id=95795b46&scoped=true"
import script from "./TryGame.vue?vue&type=script&lang=js"
export * from "./TryGame.vue?vue&type=script&lang=js"

import "../../styles/removeVantcell.css?vue&type=style&index=0&id=95795b46&scoped=true&lang=css"
import "./TryGame.vue?vue&type=style&index=1&id=95795b46&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95795b46"]])

export default __exports__